import { render } from "./Home.vue?vue&type=template&id=33723aac&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=33723aac&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-33723aac"

export default script